import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PointsDisplay from './PointsDisplay';
import { onImageError } from '../utils/imageFallback';
import { useLanguage } from '../i18n';

const Header: React.FC = () => {
  const { user, isAuthenticated, isLoading, signInWithGoogle } = useAuth();
  const { t } = useLanguage();
  const { pathname } = useLocation();

  const username = user?.username || null;
  const pseudo = user?.pseudo || null;
  const userId = user?.id || null;
  const hasYoutubeChannel = user?.has_youtube_channel || false;
  const avatarUrl = user?.avatar_url || null;

  // Sur la page courante, le lien ne provoque aucune navigation : on remonte
  // en haut, comme le logo YouTube.
  const handleLogoClick = () => {
    if (pathname === '/') window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Use username if available, otherwise use userId for profile URL
  const profileUrl = username ? `/${username}` : userId ? `/${userId}` : null;

  return (
    <header className="header">
      <div className="header-inner">
        <Link to="/" className="header-logo" onClick={handleLogoClick}>
          <img src="/logo192.png" alt="pickthumb" className="header-logo-img" />
          <span className="header-logo-text">pickthumb</span>
        </Link>

        <div className="header-center">
          {(isAuthenticated && hasYoutubeChannel) && (
            <Link to="/add" className="header-nav-add">
              {t.header.add}
            </Link>
          )}
        </div>

        <div className="header-right">
          {isAuthenticated ? (
            profileUrl && pseudo ? (
              <Link to={profileUrl} className="header-username">
                {avatarUrl && (
                  <img
                    src={avatarUrl}
                    alt=""
                    className="header-avatar image-skeleton"
                    onError={onImageError}
                  />
                )}
                <span className="header-username-text">{pseudo}</span>
                <PointsDisplay />
              </Link>
            ) : (
              <span className="header-username">{t.header.loading}</span>
            )
          ) : (
            <button
              className="header-button youtube"
              onClick={signInWithGoogle}
              disabled={isLoading}
            >
              {isLoading ? '...' : <><span className="header-button-full">{t.header.loginYoutube}</span><span className="header-button-short">{t.header.loginShort}</span></>}
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
